export class TextUtils {
  static maskText(value: string, visibleChars: number, maskChar: string): string {
    if (!value) return '';
    const visible = value.slice(0, visibleChars);
    const masked = value.slice(visibleChars).replace(/./g, maskChar);
    return visible + masked;
  }

  static truncateText(value: string, maxLength: number): string {
    return value.length > maxLength ? value.slice(0, maxLength) + '...' : value;
  }

  static hideFullText(value: string, maskChar: string): string {
    return value.replace(/./g, maskChar);
  }

  static getLocalizedText(value: any, langCode: string | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }

    let parsed = value;
    if (typeof value === 'string') {
      const trimmed = value.trim();
      if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
        try {
          parsed = JSON.parse(trimmed);
        } catch (_) {
          parsed = value;
        }
      }
    }

    if (Array.isArray(parsed)) {
      if (parsed.length === 0) return '';
      return this.getLocalizedText(parsed[0], langCode);
    }

    if (typeof parsed !== 'object' || parsed === null) {
      return String(parsed);
    }

    if (langCode) {
      const code = langCode.toLowerCase();
      if (parsed[langCode] && String(parsed[langCode]).trim().length > 0) {
        return String(parsed[langCode]);
      }
      for (const k of Object.keys(parsed)) {
        if (k.toLowerCase() === code && parsed[k] && String(parsed[k]).trim().length > 0) {
          return String(parsed[k]);
        }
      }
    }

    if (parsed['tr'] && String(parsed['tr']).trim().length > 0) return String(parsed['tr']);
    if (parsed['en'] && String(parsed['en']).trim().length > 0) return String(parsed['en']);

    const objectValues = Object.values(parsed).filter(
      v => v !== null && v !== undefined && String(v).trim().length > 0
    );
    if (objectValues.length > 0) {
      return String(objectValues[0]);
    }

    return '';
  }
}
